/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actions
import { updatePartnerLogo, setEmbedProperty, setPartnerLogoSrc, setPartnerLogoUrl, toggleShowPartnerLogo } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { setContentProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import EmbedProperties from 'pages/dashboard/embeds/management/customize/embedproperties/embedproperties';




/* ========== ~~~~~~~~~~ PROPERTY EDITOR : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    accountUUID: sessionStatus.accountUUID,
    partnerLogo: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.partnerLogo,
    brandColor: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.brandColor,
    contentId: embedsState.embedManagementState.contentStatus['selectedContent'],
    showPartnerLogo: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.showPartnerLogo,
    noLiveContents: embedsState.embedManagementState.contentStatus.noLiveContents,
    location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location
});

// map actions
const mapDispatchToProps = dispatch => ({
    updatePartnerLogo: (accountUUID, imageFile) => dispatch(updatePartnerLogo(accountUUID, imageFile)),
    setPartnerLogoSrc: logoSource => dispatch(setPartnerLogoSrc(logoSource)),
    setEmbedProperty: (property, value) => dispatch(setEmbedProperty(property, value)),
    // setContentProperty: (contentId, property, value) => dispatch(setContentProperty(contentId, property, value)),
    setPartnerLogoUrl: url => dispatch(setPartnerLogoUrl(url)),
    toggleShowPartnerLogo: bool => dispatch(toggleShowPartnerLogo(bool))
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmbedProperties);
